import { render, staticRenderFns } from "./Spread.vue?vue&type=template&id=4ae28690&scoped=true"
import script from "./Spread.vue?vue&type=script&lang=js"
export * from "./Spread.vue?vue&type=script&lang=js"
import style0 from "./Spread.vue?vue&type=style&index=0&id=4ae28690&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae28690",
  null
  
)

export default component.exports